import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=fd7b57c2&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
import style0 from "./Banner.vue?vue&type=style&index=0&id=fd7b57c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7b57c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd7b57c2')) {
      api.createRecord('fd7b57c2', component.options)
    } else {
      api.reload('fd7b57c2', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=fd7b57c2&scoped=true", function () {
      api.rerender('fd7b57c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cont/Banner.vue"
export default component.exports